import { ReactNode } from 'react';
import {
  StyledIconContainer,
  StyledReleaseOptionContainer,
  StyledSubTitle,
  StyledTextContainer,
  StyledTitle,
} from './styled';

interface ReleaseOptionProps {
  title: string;
  subTitle: string;
  onClick: () => void;
  icon: ReactNode;
}

const ReleaseOption = ({
  title,
  subTitle,
  onClick,
  icon,
}: ReleaseOptionProps) => (
  <StyledReleaseOptionContainer onClick={onClick}>
    <StyledIconContainer>{icon}</StyledIconContainer>
    <StyledTextContainer>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubTitle>{subTitle}</StyledSubTitle>
    </StyledTextContainer>
  </StyledReleaseOptionContainer>
);

export default ReleaseOption;
